"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('../');
var ɵngcc2 = require('../../../enumeration-type');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var enumeration_type_1 = require("../../../enumeration-type");
var __1 = require("../");
var BaseProductsService = /** @class */ (function () {
    /**
     * Initialises a new instance of the BaseProductsService class.
     * @param productsService
     */
    function BaseProductsService(productsService, module) {
        this.productsService = productsService;
        this.module = module;
    }
    /**
      * Add Manual Message
      * @param deliverableId
      * @param transferOwnerRequest
      * @returns An Observable containing the IDeliverableFeatureEditable
      */
    BaseProductsService.prototype.AddMessageAsync = function (deliverableId, feedbackRequest) {
        return this.productsService.AddMessageAsync(deliverableId, feedbackRequest, this.module);
    };
    /**
        * Adjust Work Slot.
        * @param deliverableId
        * @param addWorkRequest
        * @returns An Observable containing boolean
        */
    BaseProductsService.prototype.AddProjectWorkAsync = function (deliverableId, addWorkRequest) {
        return this.productsService.AddProjectWorkAsync(deliverableId, addWorkRequest, this.module);
    };
    /**
       * Adjust Term.
       * @param adjustDeliverableTermRequest
       * @returns An Observable containing the DeliverableBase
       */
    BaseProductsService.prototype.AdjustRolesAsync = function (deliverableId, adjustHeadRolesRequest) {
        return this.productsService.AdjustRolesAsync(deliverableId, adjustHeadRolesRequest, this.module);
    };
    /**
       * Adjust Term.
       * @param adjustDeliverableTermRequest
       * @returns An Observable containing the DeliverableBase
       */
    BaseProductsService.prototype.AdjustLineRolesAsync = function (deliverableId, phaseId, adjustLineRolesRequest) {
        return this.productsService.AdjustLineRolesAsync(deliverableId, phaseId, adjustLineRolesRequest, this.module);
    };
    /**
      * Adjust Work Slot.
      * @param deliverableId
      * @param adjustWorkSlotRequest
      * @returns An Observable containing boolean
      */
    BaseProductsService.prototype.AdjustWorkSlotAsync = function (deliverableId, adjustWorkSlotRequest) {
        return this.productsService.AdjustWorkSlotAsync(deliverableId, adjustWorkSlotRequest, this.module);
    };
    /**
       * Adjust Term.
       * @param adjustDeliverableTermRequest
       * @returns An Observable containing the DeliverableBase
       */
    BaseProductsService.prototype.AdjustTermAsync = function (adjustDeliverableTermRequest) {
        return this.productsService.AdjustTermAsync(adjustDeliverableTermRequest, this.module);
    };
    /**
       * Adjust Phase Term.
       * @param adjustPhaseTermRequest
       * @returns An Observable containing the DeliverableBase
       */
    BaseProductsService.prototype.AdjustPhaseTermAsync = function (adjustPhaseTermRequest) {
        return this.productsService.AdjustPhaseTermAsync(adjustPhaseTermRequest, this.module);
    };
    /**
     * Complete Client Phase Async.
     * @param approvalFeedbackRequest
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.RejectApprovalAsync = function (approvalFeedbackRequest) {
        return this.productsService.RejectApprovalAsync(approvalFeedbackRequest, this.module);
    };
    /**
     * Reject a Revision Async
     * @param approvalFeedbackRequest
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.RejectRevisionAsync = function (approvalFeedbackRequest) {
        return this.productsService.RejectRevisionAsync(approvalFeedbackRequest, this.module);
    };
    /**
     * Reject a Client Approvla Async
     * @param approvalFeedbackRequest
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.RejectClientApprovalAsync = function (approvalFeedbackRequest) {
        return this.productsService.RejectClientApprovalAsync(approvalFeedbackRequest, this.module);
    };
    /**
       * Complete Client Phase Async.
       * @param approvalFeedbackRequest
       * @returns An Observable containing the boolean
       */
    BaseProductsService.prototype.AcceptApprovalAsync = function (approvalFeedbackRequest) {
        return this.productsService.AcceptApprovalAsync(approvalFeedbackRequest, this.module);
    };
    /**
     * Cancel Project Async.
     * @param projectId
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.CancelProjectAsync = function (projectId, comment) {
        return this.productsService.CancelProjectAsync(projectId, this.module, comment);
    };
    /**
     * Complete Phase Async.
     * @param completePhaseRequest
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.CompletePhaseAsync = function (completePhaseRequest) {
        return this.productsService.CompletePhaseAsync(completePhaseRequest, this.module);
    };
    /**
     * Complete Async.
     * @param completePhaseRequest
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.CompleteAsync = function (deliverableId, completePhaseRequest) {
        return this.productsService.CompleteAsync(deliverableId, completePhaseRequest, this.module);
    };
    /**
      * Adjust Work Slot.
      * @param deliverableId
      * @param addWorkRequest
      * @returns An Observable containing boolean
      */
    BaseProductsService.prototype.ConfirmProvisionalLineAsync = function (deliverableId, phaseId, confirmProvisionalLineRequest, module) {
        return this.productsService.ConfirmProvisionalLineAsync(deliverableId, phaseId, confirmProvisionalLineRequest, this.module);
    };
    /**
      * Confirm the schedule of a To be scheduled deliverbale
      * @param ConfirmScheduleRequest
      * @returns An Observable containing the IDeliverableFeatureEditable
      */
    BaseProductsService.prototype.ConfirmScheduleAsync = function (confirmScheduleRequest, module) {
        return this.productsService.ConfirmScheduleAsync(confirmScheduleRequest, this.module);
    };
    /**
      * Create Async.
      * @param createPartialDeliverableRequest
      * @returns An Observable containing the DeliverableBase
      */
    BaseProductsService.prototype.CreatePartialAsync = function (createPartialDeliverableRequest) {
        return this.productsService.CreatePartialAsync(createPartialDeliverableRequest, this.module);
    };
    /**
     * Create Async.
     * @param createFullDeliverableRequest
     * @returns An Observable containing the DeliverableBase
     */
    BaseProductsService.prototype.CreateFullAsync = function (createFullDeliverableRequest) {
        return this.productsService.CreateFullAsync(createFullDeliverableRequest, this.module);
    };
    /**
    * Delete.
    * @param id
    * @returns An Observable containing boolean
    */
    BaseProductsService.prototype.DeleteAsync = function (id, removeParentPhaseWhenSingleInstance) {
        return this.productsService.DeleteAsync(id, this.module, removeParentPhaseWhenSingleInstance);
    };
    /**
     * FastForward Async.
     * @param phaseId
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.FastForwardAsync = function (phaseId, comment) {
        return this.productsService.FastForwardAsync(phaseId, this.module, comment);
    };
    /**
     * ForceComplete Async.
     * @param parentDeliverableId
     * @param phaseId
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.ForceCompleteAsync = function (parentDeliverableId, phaseId, comment) {
        return this.productsService.ForceCompleteAsync(parentDeliverableId, phaseId, this.module, comment);
    };
    /**
   * Gets a current deliverable phase
   * @param id
   * @returns An Observable containing the Phase
   */
    BaseProductsService.prototype.GetPhaseAsync = function (id) {
        return this.productsService.GetPhaseAsync(id, this.module);
    };
    /**
   * Gets a current deliverable project
   * @param id
   * @returns An Observable containing the Project
   */
    BaseProductsService.prototype.GetProjectAsync = function (id) {
        return this.productsService.GetProjectAsync(id, this.module);
    };
    /**
      * Lock A Deliverable Term Async.
      * @param lockDeliverableTermRequest
      * @returns An Observable containing a boolean
      */
    BaseProductsService.prototype.LockDeliverableTermAsync = function (deliverableId, lockDeliverableTermRequest) {
        return this.productsService.LockDeliverableTermAsync(deliverableId, lockDeliverableTermRequest, this.module);
    };
    /**
     * Poke Async.
     * @param deliverableId
     * @param comment
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.PokeAsync = function (deliverableId, comment) {
        return this.productsService.PokeAsync(deliverableId, this.module, comment);
    };
    /**
    * Complete Phase Async.
    * @param deliverableId
    * @param feedback
    * @returns An Observable containing the boolean
    */
    BaseProductsService.prototype.ResetPhaseAsync = function (deliverableId, feedback) {
        return this.productsService.ResetPhaseAsync(deliverableId, this.module, feedback);
    };
    /**
    * Restart Deliverable Async.
    * @returns An Observable containing the boolean
    */
    BaseProductsService.prototype.RestartDeliverableAsync = function (deliverableId, feedback) {
        return this.productsService.RestartDeliverableAsync(deliverableId, this.module, feedback);
    };
    /**
       * Remove Phase Async.
       * @param deliverableId
       * @param phaseId
       * @returns An Observable containing the boolean
       */
    BaseProductsService.prototype.RemovePhaseAsync = function (deliverableId, phaseId) {
        return this.productsService.RemovePhaseAsync(deliverableId, phaseId, this.module);
    };
    /**
     * Start Phase Async.
     * @param deliverableId
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.StartPhaseAsync = function (deliverableId, startedDate) {
        return this.productsService.StartPhaseAsync(deliverableId, this.module, startedDate);
    };
    /**
     * List By search parameters
     * @param listRequest
     * @returns An Observable containing the IDeliverableAggregatePagedList<Project>
     */
    BaseProductsService.prototype.ListAsync = function (listRequest) {
        return this.productsService.ListProjectsAsync(listRequest, this.module);
    };
    /**
     * List Phases By search parameters
     * @param listPhasesRequest
     * @returns An Observable containing the IDeliverableAggregatePagedList<PhaseWork>
     */
    BaseProductsService.prototype.ListPhasesAsync = function (listPhasesRequest) {
        return this.productsService.ListPhasesAsync(listPhasesRequest, this.module);
    };
    /**
     * List Uncreated By search parameters
     * @param listUncreatedRequest
     * @returns An Observable containing the model.IPagedList<Project>
     */
    BaseProductsService.prototype.ListUncreatedAsync = function (listUncreatedRequest) {
        return this.productsService.ListUnCreatedLines(listUncreatedRequest, this.module);
    };
    /**
       * List UnAllocated phases By search parameters
       * @param listUncreatedRequest
       * @returns An Observable containing the model.IPagedList<PhaseWork>
       */
    BaseProductsService.prototype.ListUnAllocatedPhasesAsync = function (page, pageSize) {
        return this.productsService.ListUnAllocatedPhasesAsync(page, pageSize, this.module);
    };
    /**
         * List overdue phases By search parameters
         * @returns An Observable containing the model.IPagedList<PhaseWork>
         */
    BaseProductsService.prototype.ListOverduePhasesAsync = function (page, pageSize) {
        return this.productsService.ListOverduePhasesAsync(page, pageSize, this.module);
    };
    /**
     * OnHold Project Async.
     * @param projectId
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.OnHoldProjectAsync = function (projectId, comment, hold) {
        if (hold === void 0) { hold = true; }
        return this.productsService.OnHoldProjectAsync(projectId, this.module, comment, hold);
    };
    /**
     * Put.
     * @param id
     * @param updateDeliverableRequest
     * @returns An Observable containing the DeliverableChildBase
     */
    BaseProductsService.prototype.RequestDateChangeAsync = function (deliverableId, requestDateChangeRequest) {
        return this.productsService.RequestDateChangeAsync(deliverableId, requestDateChangeRequest, this.module);
    };
    /**
   * Terminate Rolling Line
   * @param terminateRollingLineRequest
   * @returns An Observable containing the DeliverableBase
   */
    BaseProductsService.prototype.TerminateRollingLineAsync = function (terminateRollingLineRequest) {
        return this.productsService.TerminateRollingLineAsync(terminateRollingLineRequest, this.module);
    };
    /**
      * Transfer Owner.
      * @param deliverableId
      * @param transferOwnerRequest
      * @returns An Observable containing the IDeliverableFeatureEditable
      */
    BaseProductsService.prototype.TransferOwnerAsync = function (deliverableId, transferOwnerRequest) {
        return this.productsService.TransferOwnerAsync(deliverableId, transferOwnerRequest, this.module);
    };
    /**
    * Trim Unassigned Units Async.
    * @param deliverableId
    * @param comment
    * @returns An Observable containing the boolean
    */
    BaseProductsService.prototype.TrimUnAssignedUnitsAsync = function (deliverableId, feedback) {
        return this.productsService.TrimUnAssignedUnitsAsync(deliverableId, this.module, feedback);
    };
    /**
      * Put.
      * @param id
      * @param updateDeliverableRequest
      * @returns An Observable containing the DeliverableChildBase
      */
    BaseProductsService.prototype.UpdateAsync = function (id, updateDeliverableRequest) {
        return this.productsService.RenameAsync(id, updateDeliverableRequest, this.module);
    };
    /**
     * Switch Product Async.
     * @param deliverableId
     * @param phaseId
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.SwitchProductAsync = function (switchProductRequest) {
        return this.productsService.SwitchProductAsync(switchProductRequest, this.module);
    };
    /**
     * Provisional Async.
     * @param deliverableId
     * @param phaseId
     * @returns An Observable containing the boolean
     */
    BaseProductsService.prototype.ProvisionalAsync = function (deliverableId, phaseId, provisional) {
        if (provisional === void 0) { provisional = true; }
        return this.productsService.ProvisionalAsync(deliverableId, phaseId, this.module, provisional);
    };
    /**
     * Mark as To be scheduled
     * @param ToBeScheduledRequest
     * @returns An Observable containing the IDeliverableFeatureEditable
     */
    BaseProductsService.prototype.ToBeScheduledAsync = function (toBeScheduledRequest) {
        return this.productsService.ToBeScheduledAsync(toBeScheduledRequest, this.module);
    };
    /**
      * Transfer a contractline to another SOW
      * @param TransferContractLineRequest
      * @returns An Observable containing the IDeliverableFeatureEditable
      */
    BaseProductsService.prototype.TransferContractLineAsync = function (transferContractLineRequest) {
        return this.productsService.TransferContractLineAsync(transferContractLineRequest, this.module);
    };
    BaseProductsService = __decorate([ __metadata("design:paramtypes", [__1.ProductService,
            enumeration_type_1.DeliverableModule])
    ], BaseProductsService);
BaseProductsService.ɵfac = function BaseProductsService_Factory(t) { return new (t || BaseProductsService)(ɵngcc0.ɵɵinject(ɵngcc1.ProductService), ɵngcc0.ɵɵinject(ɵngcc2.DeliverableModule)); };
BaseProductsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BaseProductsService, factory: function (t) { return BaseProductsService.ɵfac(t); } });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseProductsService, [{
        type: core_1.Injectable
    }], function () { return [{ type: ɵngcc1.ProductService }, { type: ɵngcc2.DeliverableModule }]; }, null); })();
    return BaseProductsService;
}());
exports.BaseProductsService = BaseProductsService;

